import React, { useEffect, useState } from 'react';
import '../styles/EmployeeMaster.css';
import { getEmployeesForMaster, resetTravelMasterPasswords } from '../components/api/EmpMasterApi';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetTravelPasswords = () => {
     const [employees, setEmployees] = useState([]);
     const [loading, setLoading] = useState(false);
     const [selected, setSelected] = useState(new Set());
     const [search, setSearch] = useState('');
     const [message, setMessage] = useState('');
     const user_role = sessionStorage.getItem('user_role');

     useEffect(() => {
          fetchEmployees();
     }, []);

     const fetchEmployees = async () => {
          setLoading(true);
          setMessage('');
          try {
               const res = await getEmployeesForMaster({ per_page: 0, status: 'A' });
               // API may return { data: [...] } or [...] directly
               const data = Array.isArray(res.data) ? res.data : (Array.isArray(res) ? res : (res.data || []));
               setEmployees(data);
          } catch (err) {
               console.error('Error fetching employees:', err);
               setMessage('Error fetching employees');
          } finally {
               setLoading(false);
          }
     };

     const toggleSelection = (code) => {
          const next = new Set(selected);
          if (next.has(code)) next.delete(code); else next.add(code);
          setSelected(next);
     };

     const selectAllVisible = (checked) => {
          const visible = filteredEmployees.map(e => e.employee_code);
          const next = new Set(selected);
          if (checked) visible.forEach(c => next.add(c)); else visible.forEach(c => next.delete(c));
          setSelected(next);
     };

     const handleReset = async () => {
          if (selected.size === 0) return;
          if (!window.confirm(`Reset password for ${selected.size} employees?`)) return;
          setLoading(true);
          setMessage('');
          try {
               const codes = Array.from(selected);
               const res = await resetTravelMasterPasswords(codes);
               const successMsg = res.message || 'Passwords reset successfully';
               setMessage(successMsg);
               // show toast only for allowed roles
               if (user_role === 'SUPER_ADMIN' || user_role === 'HR') {
                    toast.success(successMsg, { autoClose: 3000 });
               }
               setSelected(new Set());
          } catch (err) {
               console.error(err);
               const errMsg = err.message || 'Failed to reset passwords';
               setMessage(errMsg);
               if (user_role === 'SUPER_ADMIN' || user_role === 'HR') {
                    toast.error(errMsg, { autoClose: 5000 });
               }
          } finally {
               setLoading(false);
          }
     };

     const filteredEmployees = employees.filter(e => {
          const name = (e.name || e.employee_name || e.full_name || '').toString().toLowerCase();
          const code = (e.employee_code || e.code || '').toString().toLowerCase();
          const q = search.trim().toLowerCase();
          if (!q) return true;
          return name.includes(q) || code.includes(q);
     });

     return (
          <div className="employee-master-page">
               <h3>Reset Passwords</h3>

               <div style={{ marginBottom: 12 }}>
                    <input
                         type="text"
                         placeholder="Search by name or code"
                         value={search}
                         onChange={e => setSearch(e.target.value)}
                         style={{ padding: '6px 8px', width: 300, marginRight: 12 }}
                    />
                    <button className='btn btn-sm btn-info' onClick={fetchEmployees} disabled={loading}>Refresh</button>
               </div>

               {message && <div style={{ marginBottom: 12, color: 'green' }}>{message}</div>}

               <div className="employee-table" style={{ maxHeight: 400, overflow: 'auto', border: '1px solid #ddd' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                         <thead>
                              <tr>
                                   <th style={{ padding: 8, borderBottom: '1px solid #eee' }}>
                                        <input
                                             type="checkbox"
                                             onChange={e => selectAllVisible(e.target.checked)}
                                             checked={filteredEmployees.length > 0 && filteredEmployees.every(e => selected.has(e.employee_code))}
                                        />
                                   </th>
                                   <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #eee' }}>Name</th>
                                   <th style={{ textAlign: 'left', padding: 8, borderBottom: '1px solid #eee' }}>Employee Code</th>
                              </tr>
                         </thead>
                         <tbody>
                              {loading && <tr><td colSpan={3} style={{ padding: 12 }}>Loading...</td></tr>}
                              {!loading && filteredEmployees.length === 0 && <tr><td colSpan={3} style={{ padding: 12 }}>No employees found.</td></tr>}
                              {!loading && filteredEmployees.map(emp => (
                                   <tr key={emp.employee_code}>
                                        <td style={{ padding: 8, borderBottom: '1px solid #f6f6f6' }}>
                                             <input
                                                  type="checkbox"
                                                  checked={selected.has(emp.employee_code)}
                                                  onChange={() => toggleSelection(emp.employee_code)}
                                             />
                                        </td>
                                        <td style={{ padding: 8, borderBottom: '1px solid #f6f6f6' }}>{emp.name || emp.employee_name || emp.full_name || '—'}</td>
                                        <td style={{ padding: 8, borderBottom: '1px solid #f6f6f6' }}>{emp.employee_code}</td>
                                   </tr>
                              ))}
                         </tbody>
                    </table>
               </div>

               <div style={{ marginTop: 12 }}>
                    <button className='btn btn-sm btn-info' onClick={handleReset} disabled={selected.size === 0 || loading} style={{ marginRight: 8 }}>Reset Passwords</button>
                    <button className='btn btn-sm btn-secondary' onClick={() => { setSelected(new Set()); setMessage(''); }}>Clear</button>
               </div>

               <ToastContainer position="top-right" />
          </div>
     );
};

export default ResetTravelPasswords;
